/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreYandexGamesYandexBonusSuccessResult interface.
 */
export function instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult(value) {
    if (!('ConsumeToken' in value) || value['ConsumeToken'] === undefined)
        return false;
    if (!('UniqueId' in value) || value['UniqueId'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('PublicOrderId' in value) || value['PublicOrderId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ConsumeToken': json['ConsumeToken'],
        'UniqueId': json['UniqueId'],
        'Sku': json['Sku'],
        'PublicOrderId': json['PublicOrderId'],
    };
}
export function FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ConsumeToken': value['ConsumeToken'],
        'UniqueId': value['UniqueId'],
        'Sku': value['Sku'],
        'PublicOrderId': value['PublicOrderId'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreYandexGamesYandexBonusSuccessResult.js.map